import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["defaultChecked", "checked", "onChange", "inputProps"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React, { forwardRef, useState, useEffect, useImperativeHandle, useRef } from 'react';
import Switch from '@mui/material/Switch';
import omit from 'lodash/omit';
import { useHoistFocusVisibleClass } from '../utils/useHoistFocusVisibleClass';
export var SWITCH_FOCUS_VISIBLE_CLASS = 'EmbersSwitch-focusVisible';
var BaseSwitch = function BaseSwitch(_ref, ref) {
  var defaultChecked = _ref.defaultChecked,
    checked = _ref.checked,
    onChange = _ref.onChange,
    inputProps = _ref.inputProps,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var refBaseSwitch = useRef(null);
  var _useState = useState(defaultChecked || false),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  useImperativeHandle(ref, function () {
    return refBaseSwitch.current;
  });
  useEffect(function () {
    typeof checked !== 'undefined' && setValue(checked);
  }, [checked]);
  var onDataChange = function onDataChange(event, checked) {
    setValue(checked);
    onChange === null || onChange === void 0 || onChange(event, checked);
  };
  var visibleFocusHoister = useHoistFocusVisibleClass({
    focusVisibleClass: SWITCH_FOCUS_VISIBLE_CLASS,
    classToHarvestFrom: 'MuiButtonBase-root',
    classToApplyTo: 'MuiSwitch-root'
  });
  return /*#__PURE__*/React.createElement(Switch, _extends({
    ref: refBaseSwitch,
    inputRef: visibleFocusHoister.collectInputRef,
    checked: value,
    onChange: onDataChange,
    inputProps: _objectSpread({
      role: 'switch',
      'aria-label': otherProps['aria-label']
    }, inputProps)
    // According to commit "ENGA-4111-Code Review changes are made"(a195b1a7b4df30299ca45e989af3024dd5faf419), the aria-label prop is passed to the inputProps, so it is removed from the otherProps
  }, omit(otherProps, ['aria-label'])));
};
export var EmbersBaseSwitch = /*#__PURE__*/forwardRef(BaseSwitch);